import VueRouter from 'vue-router';

let routes = [
    // {
    //     path: '/',
    //     name: 'business.offers.indexed',
    //     component: BusinessAndFleetIndex,
    //     props: true,
    // },
    {
        path: '/business/offers',
        name: 'business.results',
        component: () => import('./BusinessAndFleetSearch.vue'),
        props: false,
    },
    {
        path: '/:brand/business/offers',
        name: 'business.results.brand',
        component: () => import('./BusinessAndFleetSearch.vue'),
        props: true,
    },
    {
        path: '/:brand/business/offers/:id/:slug',
        name: 'business.offers.show',
        component: () => import('./BusinessAndFleetShow.vue'),
        props: true,
    },
];

let scrollBehavior = function(to, from, savedPosition) {
    if (to.hash) {
        return {
            selector: to.hash
            , offset: {x:0, y:105}
        };
    }
    return { selector: 'body', offset: {x:0, y:105} };
};

export default new VueRouter({
    mode: 'history',
    routes,
    scrollBehavior,
    base: '/',
    linkActiveClass: 'active',
});